export default function ApprocheSection() {
  return (
    <section className="bg-brand-noir py-28 lg:py-40">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-32 items-center">
          {/* Left: Title */}
          <div>
            <span className="font-sans text-xs tracking-widest uppercase text-brand-gris-light mb-6 block">
              Approche
            </span>
            <h2 className="font-serif font-light text-brand-or-light text-4xl lg:text-5xl xl:text-6xl leading-tight">
              Simplicité,<br />équilibre,<br />cohérence.
            </h2>
            <div className="mt-10 w-16 h-px bg-brand-or/50"></div>
          </div>

          {/* Right: Text */}
          <div>
            <p className="font-sans font-light text-white/80 text-lg leading-loose mb-8">
              Notre approche repose sur la simplicité, l'équilibre et la cohérence. Chaque projet
              est conçu sur mesure pour refléter l'identité du client tout en garantissant une
              esthétique contemporaine et durable.
            </p>
            <p className="font-sans font-light text-white/50 text-base leading-loose">
              Chaque projet est pensé avec exigence, précision et sens du détail afin de produire
              un résultat à la fois esthétique et stratégique.
            </p>
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-24 pt-16 border-t border-white/10">
          {[
            { number: "100", label: "Projets réalisés" },
            { number: "8", label: "Années d'expertise" },
            { number: "50", label: "Marques accompagnées" },
            { number: "3", label: "Services spécialisés" },
          ].map((stat, i) => (
            <div key={i} className="text-center lg:text-left">
              <div className="font-serif font-light text-white text-6xl lg:text-7xl leading-none">
                {stat.number}
                <span className="text-brand-or text-3xl align-super">+</span>
              </div>
              <p className="font-sans text-xs tracking-widest uppercase text-brand-gris-light mt-4">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
